export default __webpack_public_path__ + "static/media/Avatar-14.8589383a.svg";